import { cn } from '@divlab/divanui';

import styles from './Burger.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface BurgerProps extends HTMLAttributes<HTMLButtonElement> {
  className?: string;
}

const Burger: FC<BurgerProps> = (props) => {
  const { className, ...restProps } = props;

  return (
    <button
      {...restProps}
      type='button'
      className={cn(styles.burger, className)}
      aria-label='Меню'
    />
  );
};

export default Burger;
